import ActionCostFilter from 'modules/Recommendations/CampaignsRecommendations/Type/filters/action-cost'
import CampaignBudgetFilter from 'modules/Recommendations/CampaignsRecommendations/Type/filters/campaign-budget'
import AccountBalanceFilter from 'modules/Recommendations/CampaignsRecommendations/Type/filters/account-balance'
import YandexMetrikaFilter from 'modules/Recommendations/CampaignsRecommendations/Type/filters/yandex-metrika'
import StrategyLearningFilter from 'modules/Recommendations/CampaignsRecommendations/Type/filters/strategy-learning'

export default {
  'action-cost': ActionCostFilter,
  'campaign-budget': CampaignBudgetFilter,
  'account-balance': AccountBalanceFilter,
  'yandex-metrika': YandexMetrikaFilter,
  'strategy-learning': StrategyLearningFilter,
}
